import {Schema} from 'simpli-web-sdk'
import StatusNotificacaoAuditoria from '@/model/resource/StatusNotificacaoAuditoria'

export default (model: StatusNotificacaoAuditoria): Schema => ({
  idStatusNotificacaoAuditoriaPk: {
    content: model.idStatusNotificacaoAuditoriaPk,
  },

  nome: {
    content: model.nome,
  },
})
